import { Outlet, createFileRoute } from "@tanstack/react-router";
import { MessageChatCircle } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_messenger")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("messenger", context.tenant.modules);

    return {
      title: () => context.t("Messenger", { ns: "messenger.shared" }),
      crumb: [
        {
          Icon: MessageChatCircle,
        },
        {
          label: context.t("Messenger", { ns: "messenger.shared" }),
          link: { to: "/admin/messenger/groups" },
        },
      ],
    } satisfies ChildRouteContext;
  },

  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
